module.exports = __webpack_public_path__ + "img/img_3.24ce1c2b.png";